<div #QCScoreReporting id="PG_QCScoreReporting" class="glb_formBGColor glb_boxedPadding glb_Font text-white glb_Font">
  <div class="glb_Font header-padding glb_customFlexRow">
    <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
      <div class="col-12 glb_customFlexRow glb_paddingBottomMD align-items-center glb_paddingZeroOffset">
        <div class="glb_TitleLG glb_TitleLGMobile text-start glb_fontColorSkin glb_breakLongWords glb_paddingZeroOffset col-6">
          QC Feedback Score Reporting
        </div>
      </div>
    </div>
  </div>
  <div class="glb_Font header-padding glb_customFlexRow col-12">
    <div class="glb_customFlexRow glb_paddingZeroOffset">
      <div class="glb_customFlexRow glb_paddingBottomMD align-items-center glb_paddingZeroOffset">
        <div
          class="glb_customFlexRow align-items-center glb_TitleSM text-start glb_fontColorSkin text-white glb_breakLongWords glb_paddingZeroOffset">
          QC Calculations as of: {{QCFeedbackScoreCalcDateDisplay}}
          <div *ngIf="ShowQCScoreCacheRefreshButton"
            class="glb_customFlexRow align-items-center glb_paddingLeft justify-content-start glb_paddingZeroOffset">
            <button id="BTN_RefreshCache"
              class="glb_clickableIconButtonStyle glb_clickableIconButtonColorLight glb_clickableIconButtonMD align-self-right"
              (click)="QCScoreCacheData_Refresh()">
              <fa-icon class="fa-fw glb_fixedSizeIcons" [icon]="['fal', 'gears']" matTooltip="Click to Refresh QC Feedback Score">
              </fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="glb_customFlexRow justify-content-start col-12" style="background-color: white; padding: 10px;">
    <!-- Lender-->
    <div class="col-12">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="glb_inputFieldLabel glb_customFlexRow text-dark" style="padding-left: 5px;">Choose Lenders</div>
        <div class="glb_customFlexRow col-12">
          <div class="glb_customFlexRow justify-content-left align-items-left left-padding text-dark glb_Font glb_paddingBottomSM col-9"
            style="padding: 5px;">
            <div class="col-12">
              <p-multiSelect #INP_Lenders id="INP_Lenders" [options]="LenderList" [(ngModel)]="SelectedLenders" optionLabel="ControlDisplay"
                [appendTo]="'body'" [virtualScroll]="true" [virtualScrollItemSize]="40" [filter]="true" [resetFilterOnHide]="true"
                [showToggleAll]="true" [showClear]="false" [showHeader]="true" [selectedItemsLabel]="'{0} Lenders selected'"
                placeholder="Click to select Lenders" [disabled]="!AreInputsActive || AllLendersChecked" [selectAll]="LenderSelectAll.Value"
                (onSelectAllChange)="globalFunctions.MultiSelectAll_Toggle($event, LenderSelectAll, LenderList, SelectedLenders, INP_Lenders)"
                (onChange)="globalFunctions.MultiSelect_Toggle(LenderSelectAll, LenderList, SelectedLenders)"
                (onPanelHide)="LendersMultiSelect_PanelHide()" (onPanelShow)="LenderMultiselect_Group(LenderList,SelectedLenders)" fluid="true">
              </p-multiSelect>
            </div>
          </div>
          <div class="glb_customFlexRow justify-content-left align-items-left left-padding text-dark col-3">
            <span class="glb_customFlexRow justify-content-end align-items-center">
              <mat-checkbox id="CB_AllLenders" class="glb_Font glb_PaddingHorizontalSM mat-checkbox-light-custom" [checked]="AllLendersChecked"
                [disabled]="!AreInputsActive" (change)="AllLendersCheckBox_Click($event)">All Lenders</mat-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Assigned To-->
    <div class="col-12">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="glb_inputFieldLabel glb_customFlexRow text-dark" style="padding-left: 5px;">Choose Assignees</div>
        <div class="glb_customFlexRow col-12">
          <div class="glb_customFlexRow justify-content-left align-items-left left-padding text-dark col-9" style="padding: 5px;">
            <mat-form-field class="glb_Font glb_paddingZeroOffset mat-autocomplete-light-custom mat-autocomplete-custom" appearance="outline">
              <input id="INP_Assignees" (click)="AutoComplete_Client_ApplyFilter(AssigneeAutoComplete, 'Search',
                      insertAssignee.value, 'Assigned To', true, QCScoreReportingLinkType)" (keydown)="AutoComplete_Client_ApplyFilter(AssigneeAutoComplete, 'Search',
                      insertAssignee.value, 'Assigned To', true, QCScoreReportingLinkType)" #insertAssignee type="text" matInput
                [matAutocomplete]="insertAssignee_autoComplete" placeholder="Enter a value to search"
                [disabled]="!AreInputsActive || AllAssigneesChecked || DisableAssigneeInputFlag" class="mat-form-field-autocompleteplaceholder">
              <mat-autocomplete #insertAssignee_autoComplete="matAutocomplete" [displayWith]="AutoComplete_GetPrettyName"
                (optionSelected)="AutoComplete_SaveSelectedControlRecord($event.option, QCAssignee)" [panelWidth]="500">
                <div *ngFor="let control of AutoComplete_Client_ApplyFilter(AssigneeAutoComplete, 'Search',
                        insertAssignee.value, 'Assigned To',false, QCScoreReportingLinkType)">
                  <mat-option class="glb_Font" [value]=control>
                    {{control.ControlValue}}
                  </mat-option>
                </div>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="glb_customFlexRow justify-content-left align-items-left left-padding text-dark col-3" *ngIf="!DisableAssigneeInputFlag">
            <span class="glb_customFlexRow justify-content-end align-items-center">
              <mat-checkbox id="CB_AllAssignees" class="glb_Font glb_FontSize glb_PaddingHorizontalSM mat-checkbox-light-custom"
                [checked]="AllAssigneesChecked" [disabled]="!AreInputsActive || DisableAssigneeInputFlag"
                (change)="AllAssigneesCheckBox_Click($event)">All
                Assignees</mat-checkbox>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-md-12 col-sm-12 col-12">
        <div class="glb_inputFieldLabel glb_customFlexRow text-dark" style="padding-left: 5px;" *ngIf="!AllAssigneesChecked">Assignees Selected:</div>
        <div class="glb_customFlexRow justify-content-start row-cols-6">
          <div class="glb_customFlexRow justify-content-left align-items-left text-dark col" *ngFor=" let assignee of Assignees"
            style="padding: 3px;">
            <div class="glb_boxedPaddingNarrow glb_roundedBorderSM glb_customFlexRow align-items-center col-12 chosen-items-border"
              [ngClass]="SelectedClientBG_GetCSS(assignee)">
              <div class="col-10 glb_FontSize" matTooltip="{{assignee.ControlDisplay}}" matTooltipPosition="below">
                {{TextSize_Limit(assignee.ControlDisplay,18)}}
              </div>
              <div class="col-2">
                <span class="glb_customFlexRow justify-content-end align-items-center">
                  <mat-checkbox class="glb_Font mat-checkbox-light-custom" [checked]=assignee.IsChecked
                    (change)="AssigneeCheckBox_Click(assignee, $event)" [disabled]="!AreInputsActive || DisableAssigneeInputFlag"></mat-checkbox>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="glb_inputFieldLabel glb_customFlexRow text-dark col-12" style="padding-left: 5px;">Source:</div>
      <div class="col-lg-2 col-md-6 col-sm-6 col-12 glb_customFlexRow" style="padding-left:5px;">
        <mat-form-field appearance="outline">
          <mat-select #matSelect id="DU_MatSelect" class="glb_Font" [(value)]="Source" placeholder="Choose source" [disabled]="!AreInputsActive"
            (blur)="globalFunctions.MatSelectOverlay_Close(matSelect)">
            <div *ngFor="let control of ControlData_Filter('Task Source')">
              <mat-option class="glb_Font" value={{control.ControlGUID}}>
                {{control.ControlDisplay}}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="col-12 glb_customFlexRow glb_paddingTopSM">
      <div class="glb_inputFieldLabel glb_customFlexRow text-dark col-12" style="padding-left: 5px;">Choose From and To Dates:</div>
      <div class="col-lg-8 col-md-12 col-sm-12 col-12 glb_customFlexRow">
        <div class="glb_customFlexRow col-6 justify-content-center align-items-center" style="padding: 5px;">
          <div class="col-10 glb_floatParent" style="padding-left:0px; padding-right:0px; padding-bottom:0px;">
            <!-- <div class="glb_Font glb_inputFieldLabel glb_customFlexRow" style="font-size: 1.0em;">From Date</div> -->
            <p-datepicker id="INP_FromDate" #calendarFromDate [(ngModel)]="DTPFromDate.JSDate" class="DTPInputGrid DTPInputStyle glb_Font"
              [showTime]="true" [showSeconds]="false" [maxDate]="DTPMaxDate" [showIcon]="false" [showButtonPanel]="false" [showButtonBar]="true"
              [inline]="false" [showOtherMonths]="false" [hideOnDateTimeSelect]="false" [touchUI]="false" [dateFormat]="DTPDateFormat"
              [hourFormat]="12" [appendTo]="'body'" baseZIndex="15000" inline="false" inputStyleClass="glb_Font" placeholder="From Date"
              [disabled]="!AreInputsActive">
              <ng-template pTemplate="footer">
                <div class="glb_customFlexRow justify-content-center">
                  <button id="BTN_CloseCalendar"
                    class="glb_standardButton glb_skinLightOutline glb_clickableIconButtonStyle glb_BGColorSkin text-white"
                    (click)="DTP_Close(calendarFromDate, DTPFromDate)">OK</button>
                </div>
              </ng-template>
            </p-datepicker>
            <div class="floatTopRightCalendarQCScore">
              <span class="glb_clickableIconButtonStyleNone glb_skinLightOutline" type="button" (click)="calendarFromDate.toggle()">
                <fa-icon [icon]="['fal', 'calendar-clock']" class="fa-md" style="color:black"></fa-icon>
              </span>
            </div>
          </div>

          <!-- button to clear content inside the input box, spans a div of its own -->
          <div class="col-2 glb_PaddingHorizontalSM" style="padding-bottom:0px; padding-top:0px;">
            <!-- <button tabindex="-1"
              class="glb_clickableIconButtonStyleGrey glb_clickableIconButtonColorLight glb_clickableIconButtonMD glb_BGColorClear" type="button"
              matTooltip="Click to Clear" (click)="DTPFromDate_ClearData()">
              <fa-icon [icon]="['fal', 'eraser']" class="fa-fw glb_fixedSizeIcons"></fa-icon>
            </button> -->
          </div>
        </div>
        <div class="glb_customFlexRow col-6 justify-content-center align-items-center" style="padding: 5px;">
          <div class="col-10 glb_floatParent" style="padding-left:0px; padding-right:0px; padding-bottom:0px;">
            <!-- <div class="glb_Font glb_inputFieldLabel glb_customFlexRow" style="font-size: 1.0em;">To Date</div> -->
            <p-datepicker id="INP_ToDate" #calendarToDate [(ngModel)]="DTPToDate.JSDate" class="DTPInputGrid DTPInputStyle glb_Font" [showTime]="true"
              [showSeconds]="false" [maxDate]="DTPMaxDate" [showIcon]="false" [showButtonPanel]="false" [showButtonBar]="true" [inline]="false"
              [showOtherMonths]="false" [hideOnDateTimeSelect]="false" [touchUI]="false" [dateFormat]="DTPDateFormat" [hourFormat]="12"
              [appendTo]="'body'" baseZIndex="15000" inline="false" inputStyleClass="glb_Font" placeholder="To Date" [disabled]="!AreInputsActive">
              <ng-template pTemplate="footer">
                <div class="glb_customFlexRow justify-content-center">
                  <button id="BTN_CloseCalendar"
                    class="glb_standardButton glb_skinLightOutline glb_clickableIconButtonStyle glb_BGColorSkin text-white"
                    (click)="DTP_Close(calendarToDate, DTPToDate)">OK</button>
                </div>
              </ng-template>
            </p-datepicker>
            <div class="floatTopRightCalendarQCScore">
              <span class="glb_clickableIconButtonStyleNone glb_skinLightOutline" type="button" (click)="calendarToDate.toggle()">
                <fa-icon [icon]="['fal', 'calendar-clock']" class="fa-md" style="color:black"></fa-icon>
              </span>
            </div>
          </div>

          <!-- button to clear content inside the input box, spans a div of its own -->
          <div class="col-2 glb_PaddingHorizontalSM" style="padding-bottom:0px; padding-top:0px;">
            <!-- <button tabindex="-1"
              class="glb_clickableIconButtonStyleGrey glb_clickableIconButtonColorLight glb_clickableIconButtonMD glb_BGColorClear" type="button"
              matTooltip="Click to Clear" (click)="DTPToDate_ClearData()">
              <fa-icon [icon]="['fal', 'eraser']" class="fa-fw glb_fixedSizeIcons"></fa-icon>
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="col-lg-8 col-md-12 col-sm-12 col-12 glb_customFlexRow">
        <!-- Generate button-->
        <div *ngIf="AreInputsActive" class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="glb_paddingBottomSM glb_paddingTopSM d-grid">
            <button id="BTN_GenerateQCSummary" tabindex="3" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
              (click)="QCSummaryData_Get()">
              <span class="glb_Font glb_smallerText">Generate</span>
            </button>
          </div>
        </div>

        <!-- Modify button-->
        <div *ngIf="!AreInputsActive" class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="glb_paddingBottomSM glb_paddingTopSM d-grid">
            <button id="BTN_ModifyQCSummary" tabindex="3" class="glb_clearButton glb_skinLightOutline btn glb_BGColorClear text-white"
              (click)="QCFeedbackDataInputs_Toggle()" [disabled]="ShowSpinner">
              <span class="glb_Font glb_smallerText">Modify</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- QC Summary -->
  <div>
    <div>

      <QCScoreSummary #QCSummary [QCScoreReporting]="this" [AggregateData]="this.QCScoreSummary" [QCScoreColors]="this.QCColors" TabName="LBL_Active"
        [OverrideDueDateFlag]=0 [TaskTypeLengthLimit]=25 [IsActiveNavTab]=true>
      </QCScoreSummary>
    </div>
  </div>

</div>